import Highlighter from 'react-highlight-words';
import React from 'react';
import isNumber from 'lodash/isNumber';
import truncate from 'lodash/truncate';
import { Feed, Flag, Icon, Label, Message } from 'semantic-ui-react';

import { formatDatetime } from '../../Utils';
import { ArticleLink, UserLink, BoardLink } from '../../Links';

const CONTENT_TEXT_LENGTH = 150;

const Article = ({
  active,
  authorId,
  board,
  city,
  code2,
  content,
  country,
  datetime,
  id,
  isHidden,
  numHates,
  numLikes,
  numReplies,
  searchTerm,
  title,
}) => (
  <Feed size="large">
    <BoardLink id={board.id}>
      <Label
        size="small"
        color="teal"
      >
        {board.alias ?? board.title}
        {' '}
        (
        {board.title}
        )
      </Label>
    </BoardLink>
    <Feed.Event>
      <Feed.Content>
        <Feed.Summary>
          <ArticleLink id={id}>
            <Highlighter
              autoEscape
              searchWords={[searchTerm]}
              textToHighlight={title || '沒有標題喔'}
            />
          </ArticleLink>
          <Feed.Date>
            {formatDatetime(datetime)}
          </Feed.Date>
        </Feed.Summary>
        <Feed.Content>
          <Highlighter
            autoEscape
            searchWords={[searchTerm]}
            textToHighlight={truncate(content, { length: CONTENT_TEXT_LENGTH })}
          />
          {
            isHidden && (
              <Message color="olive" size="tiny">
                <Message.Header>
                  因特殊原因及原作者要求 無法顯示文章內容
                </Message.Header>
              </Message>
            )
          }
        </Feed.Content>
        <Feed.Meta>
          <Feed.Like>
            <Icon name="spy" />
            <UserLink id={authorId}>
              {authorId}
            </UserLink>
          </Feed.Like>
          {
            code2 && (
              <Feed.Like>
                <Icon name="location arrow" />
                {city}
                {' '}
                (
                {country}
                {' '}
                <Flag name={code2} />
                )
              </Feed.Like>
            )
          }
          {
            !active && (
              <Feed.Like>
                <Icon name="trash" color="red" />
                <span style={{ color: 'red' }}>
                  此文章已被刪除囉!!
                </span>
              </Feed.Like>
            )
          }
        </Feed.Meta>
        {
          isNumber(numLikes) && isNumber(numHates) && isNumber(numReplies) && (
            <Feed.Meta style={{ float: 'right' }}>
              <Feed.Like>
                <Icon color="blue" name="thumbs outline up" />
                {numLikes}
              </Feed.Like>
              <Feed.Like>
                <Icon color="red" name="thumbs outline down" />
                {numHates}
              </Feed.Like>
              <Feed.Like>
                <Icon color="yellow" name="arrow right" />
                {numReplies}
              </Feed.Like>
            </Feed.Meta>
          )
        }
      </Feed.Content>
    </Feed.Event>
  </Feed>
);

export default ({ data, searchTerm }) => (
  data.length > 0 ? (
    <Feed size="large">
      {data.map((article) => (
        <Article
          active={article.active}
          authorId={article.author_id}
          board={article.board}
          city={article.city}
          code2={article.code2}
          content={article.content}
          country={article.country}
          datetime={article.datetime}
          id={article.id}
          isHidden={article.is_hidden}
          key={article.id}
          numHates={article.num_hates}
          numLikes={article.num_likes}
          numReplies={article.num_replies}
          searchTerm={searchTerm}
          title={article.title}
        />
      ))}
    </Feed>
  ) : null
);
